<template>
  <div id="mobile-start">
    <Menu  />
    <contactForm />
    <Navbar />
    <Main  v-if="page === 'main'" />
    <Projects v-if="page === 'projects'"/>
    <Project v-if="page === 'project'"/>
    <Agency v-if="page === 'agency'"/>
    <Blog v-if="page === 'blog'"/>
    <Post v-if="page === 'post'"/>
  </div>
</template>

<script>
import Navbar from "./mobile/reuseable/navbar";
import Menu from "@/components/mobile/pages/menu";
import contactForm from "@/components/mobile/pages/contact";

import Main from "@/components/mobile/pages/main.vue";
import Projects from "@/components/mobile/pages/projects";
import Project from "@/components/mobile/pages/project";
import Agency from "@/components/mobile/pages/agency";
import Blog from "@/components/mobile/pages/blog";
import Post from "@/components/mobile/pages/post";
import {mapState} from "vuex";

export default {
  name: "mobile",
  computed:{
    ...mapState(['page'])
  },
  components: {
    Navbar,
    Menu,
    contactForm,
    Main,
    Projects,
    Project,
    Agency,
    Blog,
    Post
  },
};
</script>

<style></style>
